import type { Organisation } from '../types'

export default [
  {
    is_published: true,
    name: 'McDonald\'s',
    id: 'mcdoanlds',
    description: 'McDonald\'s er en av verdens største restaurantkjeder og en dominerende aktør i fastfoodmarkedet. Med milliarder i omsetning og millioner av kunder har de en unik mulighet til å forbedre dyrevelferden i sin forsyningskjede. Som en stor innkjøper av kjøtt og andre animalske produkter, har McDonald\'s et ansvar for hvordan dyrene behandles. De kan stille strengere krav til leverandørene og offentlig forplikte seg til bedre dyrevelferd, men har hittil ikke gjort nok. McDonald\'s er blant selskapene som gjør minst for dyrene.',
    logo: {
      file_name: 'mcdoanlds.svg',
      width: 238.5,
      height: 272.7,
    },
    email: {
      active: true,
      address: 'kundeservice@no.mcd.com',
      contact_form_url: 'https://kontakt.mcdonalds.no/no/nb-no/contact-us',
      templates: [
        {
          subject: '',
          body: 'Kjære {target_name},\n\nMed vennlig hilsen,\n{full_name}\n{phone}',
        },
      ],
    },
    phone: {
      active: true,
      number: '+4723107000',
      template: [
        'Hei, har jeg kommet til {target_name}?',
        'Dette er {full_name}.',
        'Jeg ringer for å si at jeg er bekymret for dyrevelferden i McDonald\'s.',
        'Dere selger turbokylling og har ingen planer om å stoppe.',
        'Dette er sjokkerende.',
        'Venligst, stopp å selge turbokylling.',
        'Takk for at du lyttet.',
        'Ha en fin dag.',
      ],
    },
    postcard: {
      active: true,
      address: 'Food Folk Norge AS, Pløensgate 2, 0181 Oslo',
    },
    social_media: {
      active: true,
      platforms: {
        facebook: 'mcdonaldsnorge',
        instagram: 'mcdonaldsno',
        linkedin: 'mcdonald-s-norge',
        // tiktok: 'mcdonaldsnorge', // No content on account
        youtube: 'McDonaldsNorge',
        // snapchat: 'coop_norge',
        // xPost: 'Coop må droppe turbokylling! Det er ikke greit at dyrene vokser med ekstrem vekst! #FriForTurbokylling2026 https://turbokylling.no',
      },
    },
  },
] as Organisation[]

// {
//   name: 'Coop',
//   id: 'coop',
//   description: 'Coop er en av Norges største bedrifter, og står for omtrent en tredjedel av dagligvaremarkedet. Med mange milliarder i omsetning og millioner av kunder står de i en god sitasjonen til å forbedre livene til turbokyllingene. Coop er ansvarlig for produktene de selger, og det inkluderer dyrevelferden. De kan velge å etterspøre bedre dyrevelferd fra sine leverandører og offentlige kunngjøre dette, men har så langt ikke gjort det. Coop er en av de bedriftene som gjør minst for dyrene.',
//   email: undefined,
//   phone: undefined,
//   contact_form_url: 'https://kundeservice.coop.no/csp?id=csp_annet',
//   logo: {
//     file_name: 'coop.svg',
//     width: 2560,
//     height: 728,
//   },
//   social_media: {
//     facebook: 'coopnorway',
//     instagram: 'coop_norge',
//     linkedin: 'coop-norge',
//     tiktok: 'coop_norge',
//     youtube: 'coopnorge',
//     snapchat: 'coop_norge',
//     xPost: 'Coop må droppe turbokylling! Det er ikke greit at dyrene vokser med ekstrem vekst! #FriForTurbokylling2026 https://turbokylling.no',
//   },
// },
